module.exports = __webpack_public_path__ + "img/circle-p.6a147235.svg";